document.addEventListener("DOMContentLoaded", function() {


    // zobrazeni vice popisu v detailu nemovitosti
    // inspirace http://css-tricks.com/text-fade-read-more/
    //=====================================================
    (function() {
        let el, p, ps, up, totalHeight, layoutHeight, animTimer,
            estateDesc = document.querySelector('.JS-estateDesc'),
            estateDescHeight = parseFloat(getComputedStyle(estateDesc, null).height.replace("px", ""));

        if (estateDescHeight > window.setting.NEMOVITST_DESCRIPTION_HEIGHT) {
            layoutHeight = window.setting.NEMOVITST_DESCRIPTION_HEIGHT;

            //nastaveni výšky elementu, aby skryl přebytečný text
            estateDesc.style.height = layoutHeight;
            estateDesc.querySelector('.read-more').style.display = 'block';
            document.querySelectorAll('.read-more.show-more .EstateShowMoreDesc')
                .forEach(item => { item.addEventListener("click", function (e) {


                    e.preventDefault();
                    clearInterval(animTimer);

                    let desc = document.querySelectorAll('a.EstateShowMoreDesc');
                    desc.forEach((el) => { el.classList.remove('active'); });
                    this.classList.add('noactive');
                    desc.forEach((el) => { el.classList.remove('noactive'); });
                    this.classList.add('active');

                    totalHeight = 0

                    el = this;
                    p  = el.parentNode;
                    up = p.parentNode;
                    ps = up.querySelectorAll("p");

                    // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
                    ps.forEach(function (el) {
                        totalHeight += el.offsetHeight + 50;
                    });

                    if(!up.classList.contains('long')){

                        up.style.height = parseFloat(getComputedStyle(up, null).height.replace("px", ""));
                        up.style.maxHeight = 9999 + 'px';

                        animJs.custom(up, 'height', totalHeight);
                        up.classList.toggle('long');

                    } else {
                        animJs.custom(up, 'height', layoutHeight);
                        up.classList.toggle('long');
                    }
                })
            });
        }
    }());
});